import { createColumnHelper, CellContext } from "@tanstack/react-table";
import React, { useRef, useState } from "react";
import Select from "react-select";
import { AdminListaPaginationTab } from "../../../controls/AdminListaPaginationTab";
import { IComboboxOption } from "../../../entities/helper/IComboboxOption";
import IAuditoria from "../../../entities/IAuditoria";
import IPlanificacion from "../../../entities/IPlanificacion";
import { IProducto } from "../../../entities/IProducto";
import { IProveedor } from "../../../entities/IProveedor";
import { ITipoProceso } from "../../../entities/ITipoProceso";
import { shortDate } from "../../../helpers/dateHelper";
import { ITipo_Campo } from "../../../helpers/IFormHelper";
import { getAPI, getAPIBlob, postAPI } from "../../../helpers/httpHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import {
  ROW_COUNT,
  URL_SUPPORT,
  API_ADMIN_TIPO_PROCESO,
  API_ADMIN_PRODUCTO,
  API_ADMIN_PROVEEDOR,
  API_PROVEEDOR_GET_PLANIFICACIONES,
  URL_PROVIDER,
  API_ROLES_USERS,
} from "../../../helpers/variableHelper";
import { E_EstadoPlanificacion } from "../../../enums/E_EstadoProveedor";
import { cognitoUserInfo } from "../../../helpers/userHelper";
import AdminLista from "../../administration/AdminLista";
import RenderTitle from "../../../controls/RenderTitle";
import RenderValue from "../../../controls/RenderValue";
import { cParamsActiveOrderTitle, cParamsActive } from "../../../helpers/paramsHelper";

interface IProveedoresProps {
  token: string;
  isHistorico: boolean;
  items?: Array<IPlanificacion>;
  cbTipoProceso?: Array<ITipoProceso>;
  cbProducto?: Array<IProducto>;
  cbProveedor?: Array<IProveedor>;
  is_Test?: boolean;
}
export default function Proveedores({ token, isHistorico, items, cbTipoProceso, cbProducto, cbProveedor, is_Test = false }: IProveedoresProps) {
  const [isLoading, setIsLoading] = useState(true);

  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  const [crearPrograma, setCrearPrograma] = useState<boolean>(false);
  const [isValidate, setIsValidate] = useState<boolean>(false);
  const refTxtAnio = React.createRef<HTMLInputElement>();
  const refTxtFechaDesde = React.createRef<HTMLInputElement>();
  const [comboTP, setComboTP] = useState<Array<ITipoProceso>>(cbTipoProceso || []);
  const [comboPR, setComboPR] = useState<Array<IProveedor>>(cbProveedor || []);
  const [comboPS, setComboPS] = useState<Array<IProducto>>(cbProducto || []);
  const [listPlanificaciones, setPlanificaciones] = useState<Array<IPlanificacion>>(items || []);
  const [refComboTP, setValComboTP] = useState<IComboboxOption | null>(null);
  const [refComboPS, setValComboPS] = useState<IComboboxOption | null>(null);
  const [refComboPR, setValComboPR] = useState<IComboboxOption | null>(null);

  const totalPageList = useRef<number>(0);

  const [filtersState, setFiltersState] = useState<any>({});
  const [loaded, setLoaded] = useState(false);
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentOpciones2 = (info: any) => {
    let url = `/agregarprograma?id=${info.row.original.ID}&id_planificacion=${info.row.original.ID_PLAN}`;

    if (info.row.original.ID_EVALUACION !== undefined) {
      url += `&id_evaluacion=${info.row.original.ID_EVALUACION}`;
    }

    return (
      <div>
        <i
          className="bi bi-search iconSearch"
          title="Ver planificación"
          onClick={() => {
            window.location.href = url;
          }}></i>
      </div>
    );
  };

  const componentOpciones = (info: any) => {
    let url = `/agregarprograma?id=${info.row.original.ID}&id_planificacion=${info.row.original.ID_PLAN}`;
    if (info.row.original.ID_EVALUACION !== undefined) {
      url += `&id_evaluacion=${info.row.original.ID_EVALUACION}`;
    }
    return (
      <div>
        <i
          className="bi bi-search iconSearch"
          title="Ver planificación"
          onClick={() => {
            window.location.href = url;
          }}></i>
        {info.row.original.ESTADO_PLANIFICACION === "En construcción" || info.row.original.ESTADO_PLANIFICACION === "Plan Informado" ? (
          <></>
        ) : (
          <i
            className="bi bi-file-earmark-arrow-down-fill iconDescarga"
            title="Descargar"
            onClick={async () => {
              let ruta = `IMGDocumentosProveedores/${info.row.original.ID}/InformeProveedores(${info.row.original.ID_PLAN}).pdf`;
              getAPIBlob(`${URL_PROVIDER}${API_PROVEEDOR_GET_PLANIFICACIONES}/GetContenidoDocumentoProveedor?ruta=${ruta}`, {
                Authorization: `Bearer ${token}`,
              }).then((r) => {
                descargar(r, ruta);
              });
            }}></i>
        )}
      </div>
    );
  };

  const componentMedidas = (info: any) => {
    return (
      <>
        {info.getValue() != undefined && info.getValue().length > 0 ? (
          <table className="table table-hover tablaTLC2 table-sm">
            <thead>
              <tr>
                <th>Responsable</th>
                <th>Medida</th>
                <th>Fecha compromiso</th>
                <th>Fecha ejecución</th>
                <th>Estado medidas</th>
              </tr>
            </thead>
            <tbody>
              {info.getValue().map((m: any) => {
                return (
                  <tr key={m}>
                    <td width="100px">{m.RESPONSABLE_DISPLAY}</td>
                    <td width="100px">
                      <i className="justify-medida-text">{m.MEDIDA}</i>
                    </td>
                    <td width="100px">{shortDate(m.FECHA_COMPROMISO)}</td>
                    <td width="100px">{shortDate(m.FECHA_REALIZACION)}</td>
                    <td width="100px">{m.ESTADO_MEDIDA}</td>
                  </tr>
                );
              })}{" "}
            </tbody>
          </table>
        ) : (
          <i>No se encontraron medidas</i>
        )}
      </>
    );
  };

  const componentObservaciones = (info: any) => {
    return <div className="justify-text">{info.getValue()}</div>;
  };
  usePromiseEffect(async () => {
    setIsLoading(true);
    if (!loaded) {
      let anio = new Date().getFullYear().toString();
      (refTxtAnio.current as HTMLInputElement).value = anio;

      let currUser = await cognitoUserInfo();
      const roles = (
        await getAPI(
          `${URL_SUPPORT}${API_ROLES_USERS}/getall`,
          { Authorization: `Bearer ${token}` },
          {
            ...cParamsActive,
            ORIENTACION: "DESC",
            USUARIO_DISPLAY: currUser.email,
          }
        )
      ).result;

      const combo = is_Test
        ? []
        : (await getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_PROCESO}/getall`, { Authorization: `Bearer ${token}` }, cParamsActiveOrderTitle)).result.data;

      setComboTP(combo);

      let tiene_rol = is_Test ? true : roles.data.some((d: any) => d.ACTIVO === true && d.ID_ROLES.some((id: number) => id === 47 || id === 49));
      setCrearPrograma(tiene_rol);
      reload(undefined, tiene_rol, is_Test);
    }

    setIsLoading(false);
  }, []);

  const validar = async () => {
    let r = (
      await postAPI(
        `${URL_PROVIDER}${API_PROVEEDOR_GET_PLANIFICACIONES}/PostValidarPlanificacion`,
        {
          ID: E_EstadoPlanificacion.PlanInformado,
        },
        { Authorization: `Bearer ${token}` }
      )
    ).result;
    console.log(r);
    window.location.href = "/proveedores/home";
  };

  const reload = async (filtros?: any, is_admin: boolean = false, is_test: boolean = false) => {
    let paramsActive = {
      ...cParamsActive,
      PAGINADO: isHistorico ? ROW_COUNT : 1000000,
      ORDENADOPOR: `PF."ID"`,
      ORIENTACION: "DESC",
    };

    let f = filtros === undefined ? paramsActive : filtros;
    let historico = "";
    f.ANIO = refTxtAnio.current?.value ?? new Date().getFullYear();
    if (isHistorico) {
      historico = `${URL_PROVIDER}${API_PROVEEDOR_GET_PLANIFICACIONES}/GetAllHistorico`;
    } else {
      historico = `${URL_PROVIDER}${API_PROVEEDOR_GET_PLANIFICACIONES}/getall`;
    }

    const planificaciones = is_test ? { data: items } : (await getAPI(historico, { Authorization: `Bearer ${token}` }, f)).result;
    setLoaded(true);
    setPlanificaciones(planificaciones.data);
    let v = planificaciones.data.filter((d: any) => d.ESTADO_PLANIFICACION === "En construcción").length > 0 && is_admin;
    setIsValidate(v);
    setPages(planificaciones.pages);
    totalPageList.current = planificaciones.pages;
  };

  const paging = (page: any) => {
    setPage(page);
    let params = { PAGINA: page };
    filter(params, true);
  };
  const filter = (filters: Partial<IPlanificacion>, page: boolean = false, size = pageSize) => {
    if (!filters) {
      filters = {};
    }
    filters.PAGINADO = isHistorico ? ROW_COUNT : 1000000;
    if (filters.PAGINA === undefined) {
      filters.PAGINA = 1;
    }
    if (!page) {
      filters.PAGINA = 1;
    }
    setPage(filters.PAGINA);

    if (filters.ORDENADOPOR === undefined) {
      filters.ORDENADOPOR = `PF."ID"`;
      filters.ORIENTACION = "DESC";
    }

    filters.ANIO = refTxtAnio.current?.value !== "" ? parseInt(refTxtAnio.current?.value ?? "0") : undefined;
    filters.TIPO_PROCESO = refComboTP?.value !== "" ? refComboTP?.label : undefined;
    filters.PRODUCTO = refComboPS?.value !== "" ? refComboPS?.label : undefined;
    filters.PROVEEDOR = refComboPR?.value !== "" ? refComboPR?.label : undefined;
    filters.FECHA_EVALUACION = refTxtFechaDesde.current?.value !== "" ? refTxtFechaDesde.current?.value : undefined;
    setFiltersState(filters);
    getAPI(
      isHistorico
        ? `${URL_PROVIDER}${API_PROVEEDOR_GET_PLANIFICACIONES}/GetAllHistorico`
        : `${URL_PROVIDER}${API_PROVEEDOR_GET_PLANIFICACIONES}/getall`,
      { Authorization: `Bearer ${token}` },
      filters
    )
      .then((result) => {
        setPages(result.result.pages);
        totalPageList.current = result.result.pages;
        console.log(result.result.data);
        setPlanificaciones(result.result.data);
        let v = result.result.data.filter((d: any) => d.ESTADO_PLANIFICACION === "En construcción").length > 0 && crearPrograma;
        setIsValidate(v);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const exportar = (filters: Partial<IPlanificacion>, page: boolean = false, size = pageSize) => {
    if (!filters) {
      filters = {};
    }
    filters.PAGINADO = 10000;
    if (filters.PAGINA === undefined) {
      filters.PAGINA = 1;
    }
    if (!page) {
      filters.PAGINA = 1;
    }
    setPage(filters.PAGINA);

    if (filters.ORDENADOPOR === undefined) {
      filters.ORDENADOPOR = `PF."ID"`;
      filters.ORIENTACION = "DESC";
    }
    filters.ANIO = refTxtAnio.current?.value !== "" ? parseInt(refTxtAnio.current?.value ?? "0") : undefined;
    filters.TIPO_PROCESO = refComboTP?.value !== "" ? refComboTP?.value : undefined;
    filters.PRODUCTO = refComboPS?.value !== "" ? refComboPS?.value : undefined;
    filters.PROVEEDOR = refComboPR?.value !== "" ? refComboPR?.value : undefined;

    setFiltersState(filters);
    getAPIBlob(
      isHistorico
        ? `${URL_PROVIDER}${API_PROVEEDOR_GET_PLANIFICACIONES}/GetExcelReporteSabana`
        : `${URL_PROVIDER}${API_PROVEEDOR_GET_PLANIFICACIONES}/getexcelproveedores`,
      { Authorization: `Bearer ${token}` },
      filters
    )
      .then((r) => {
        descargar(r, "ReporteSabana.xlsx");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const limpiar = () => {
    (refTxtAnio.current as HTMLInputElement).value = new Date().getFullYear().toString();
    if (!isHistorico) {
      (refTxtFechaDesde.current as HTMLInputElement).value = "";
    }
    setValComboPR(null);
    setComboPR([]);
    setComboPS([]);
    setValComboPS(null);
    setValComboTP(null);

    let anio = new Date().getFullYear().toString();

    const filters: any = {};
    filters.ORDENADOPOR = `PF."ID"`;
    filters.ORIENTACION = "DESC";
    filters.PAGINADO = 10000;
    filters.PAGINA = 1;
    filters.ANIO = anio;
    setFiltersState(filters);

    filter(filters);
  };
  const columnHelperProveedores = createColumnHelper<IPlanificacion>();
  let columnsDef = [
    columnHelperProveedores.accessor("ID", {
      id: "ID",
      cell: (info: CellContext<IPlanificacion, number>) => info.getValue(),
      header: () => component("ID"),
      hide: true,
      tipo: ITipo_Campo.none,
      title: "ID",
    } as any),
    columnHelperProveedores.accessor("ID_PLAN", {
      id: "ID_PLAN",
      cell: (info: CellContext<IPlanificacion, number>) => info.getValue(),
      header: () => component("Plan"),
      hide: true,
      tipo: ITipo_Campo.none,
      title: "ID_PLAN",
    } as any),
    columnHelperProveedores.accessor((row) => row.PRODUCTO, {
      id: "PRODUCTO",
      cell: (info: CellContext<IPlanificacion, string>) => componentValue(info.getValue()),
      header: () => component("Producto"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperProveedores.accessor((row) => row.NOMBRE_PROVEEDOR, {
      id: "NOMBRE_PROVEEDOR",
      cell: (info: CellContext<IAuditoria, string>) => componentValue(info.getValue()),
      header: () => component("Proveedor"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperProveedores.accessor((row) => row.USUARIO_DISPLAY, {
      id: "NOMBRE_PROVEEDOR_DISPLAY",
      cell: (info: CellContext<IPlanificacion, string>) => componentValue(info.getValue()),
      header: () => component("Nombre proveedor"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperProveedores.accessor((row) => row.TIPO_PROVEEDOR, {
      id: "TIPO_PROVEEDOR",
      cell: (info: CellContext<IAuditoria, string>) => componentValue(info.getValue()),
      header: () => component("Tipo proveedor"),
      tipo: ITipo_Campo.text,
      getGroupingValue: (row: any) => `${row.TIPO_PROVEEDOR}`,
    } as any),
    columnHelperProveedores.accessor((row) => row.EVALUADOR_LIDER_DISPLAY, {
      id: "EVALUADOR_LIDER",
      cell: (info: CellContext<IPlanificacion, string>) => componentValue(info.getValue()),
      header: () => component("Evaluador líder"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperProveedores.accessor((row) => row.EVALUADORES_DISPLAY, {
      id: "EVALUADORES",
      cell: (info: CellContext<IPlanificacion, string>) => componentValue(info.getValue()),
      header: () => component("Evaluadores"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperProveedores.accessor((row) => row.FECHA_EVALUACION, {
      id: "FECHA_EVALUACION",
      cell: (info: CellContext<IPlanificacion, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha evaluación"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperProveedores.accessor((row) => row.CORRELATIVO, {
      id: "TITULO",
      cell: (info: CellContext<IPlanificacion, string>) => componentValue(info.getValue()),
      header: () => component("Correlativo"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperProveedores.accessor((row) => row.PUNTAJE_OBTENIDO, {
      id: "CLASIFICACION",
      cell: (info: CellContext<IPlanificacion, string>) => componentValue(info.getValue()),
      header: () => component("Clasificación (%)"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperProveedores.accessor((row) => row.OBSERVACIONES, {
      id: "OBSERVACIONES",
      cell: (info: CellContext<IPlanificacion, string>) => componentObservaciones(info),
      header: () => component("Observaciones"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperProveedores.accessor((row) => row.MEDIDAS, {
      id: "MEDIDAS",
      cell: (info: CellContext<IPlanificacion, string>) => componentMedidas(info),
      header: () => component("Medidas"),
      tipo: ITipo_Campo.none,
    } as any),
    columnHelperProveedores.accessor((row) => row.ESTADO_PLANIFICACION, {
      id: "ESTADO_PLANIFICACION",
      cell: (info: CellContext<IPlanificacion, string>) => componentValue(info.getValue()),
      header: () => component("Estado evaluación"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperProveedores.accessor((row) => row.PAGINA, {
      id: "OPCIONES",
      cell: (info: CellContext<IPlanificacion, string>) => componentOpciones(info),
      header: () => component("Opciones"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
  ] as any;
  const descargar = (r: any, ruta: string) => {
    let file = r.result;
    let fileURL = URL.createObjectURL(file);
    let fileLink = document.createElement("a");
    fileLink.href = fileURL;
    fileLink.download = ruta.split("/")?.pop() || ruta;
    fileLink.click();
  };
  const columnsDefProveedores = [
    columnHelperProveedores.accessor((row) => row.ID, {
      id: "OPCIONES",
      cell: (info: CellContext<IPlanificacion, string>) => componentOpciones2(info),
      header: () => component("Opciones"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
    columnHelperProveedores.accessor("ID", {
      id: "ID",
      cell: (info: CellContext<IPlanificacion, number>) => info.getValue(), 
      header: () => component("ID"),
      hide: true,
      tipo: ITipo_Campo.none,
      title: "ID",
    } as any),
    columnHelperProveedores.accessor("ID_EVALUACION", {
      id: "ID_EVALUACION",
      cell: (info: CellContext<IPlanificacion, number>) => info.getValue(), 
      header: () => component("ID"),
      hide: true,
      tipo: ITipo_Campo.none,
      title: "ID",
    } as any),
    columnHelperProveedores.accessor((row) => row.CORRELATIVO, {
      id: "TITULO",
      cell: (info: CellContext<IPlanificacion, string>) => componentValue(info.getValue()),
      header: () => component("Planificación"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperProveedores.accessor((row) => row.FECHA_EVALUACION, {
      id: "FECHA_EVALUACION",
      cell: (info: CellContext<IPlanificacion, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha evaluación"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperProveedores.accessor((row) => row.EVALUADOR_LIDER_DISPLAY, {
      id: "EVALUADOR_LIDER",
      cell: (info: CellContext<IPlanificacion, string>) => componentValue(info.getValue()),
      header: () => component("Evaluador líder"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperProveedores.accessor((row) => row.PRODUCTO, {
      id: "PRODUCTO_COLUMNA",
      cell: (info: CellContext<IPlanificacion, string>) => componentValue(info.getValue()),
      header: () => component("Producto"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperProveedores.accessor((row) => row.NOMBRE_PROVEEDOR, {
      id: "PROVEEDOR_COLUMNA",
      cell: (info: CellContext<IPlanificacion, string>) => componentValue(info.getValue()),
      header: () => component("Proveedor"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperProveedores.accessor("ID_PLAN", {
      id: "ID_PLAN",
      cell: (info: CellContext<IPlanificacion, number>) => info.getValue(),
      header: () => component("Plan"),
      hide: false,
      tipo: ITipo_Campo.none,
      title: "ID_PLAN",
    } as any),
    columnHelperProveedores.accessor((row) => row.ANIO, {
      id: "ANIO",
      cell: (info: CellContext<IPlanificacion, number>) => info.getValue(),
      header: () => component("Año Plan"),
      hide: false,
      tipo: ITipo_Campo.none,
      title: "ANIO",
    } as any),
    columnHelperProveedores.accessor((row) => row.ESTADO_PLANIFICACION, {
      id: "ESTADO_PLANIFICACION",
      cell: (info: CellContext<IPlanificacion, string>) => componentValue(info.getValue()),
      header: () => component("Estado evaluación"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperProveedores.accessor((row) => row.AUTOR_DISPLAY, {
      id: "AUTOR",
      cell: (info: CellContext<IPlanificacion, string>) => componentValue(info.getValue()),
      header: () => component("Autor"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperProveedores.accessor((row) => row.FECHA_CREACION, {
      id: "FECHA_CREACION",
      cell: (info: CellContext<IPlanificacion, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Creado el"),
      tipo: ITipo_Campo.date,
    } as any),
  ] as any;

  return (
    <div>
      <button
        hidden={true}
        data-testid="btnreload"
        onClick={() => {
          reload({}, true, true);
        }}></button>
      <button
        hidden={true}
        data-testid="btnpaging"
        onClick={() => {
          paging(1);
        }}></button>
      <button
        hidden={true}
        data-testid="btndescargar"
        onClick={() => {
          descargar({ result: new Blob() }, "rrr");
        }}></button>
      <div className="card bg-light border p-3 pt-2 mt-2">
        <div className="row ajusteInput">
          {!isHistorico ? (
            <>
              <div className="col-sm-12 col-md-6 col-lg-4 pt-0">
                <label className="text-sm">Fecha de evaluación</label>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-4 pt-0">
                <input ref={refTxtFechaDesde} className="form-control form-control-sm w-50 me-2" type="date" placeholder="desde" />
              </div>
              <div className="col-sm-12 col-md-6 col-lg-4 pt-0"></div>
            </>
          ) : (
            <></>
          )}
          <div className="col-sm-12 col-md-6 col-lg-4 pt-0">
            <label>Año</label>
          </div>
          <div className="col-sm-12 col-md-6 col-lg-4 pt-0">
            <input ref={refTxtAnio} className="form-control form-control-sm" type="number" placeholder="Indique el año" />
          </div>
          <div className="col-sm-12 col-md-6 col-lg-4 pt-0"></div>
          <div className="col-sm-12 col-md-6 col-lg-4 pt-0">
            <label>Tipo proceso</label>
          </div>
          <div className="col-sm-12 col-md-6 col-lg-4 pt-0">
            <Select
              options={
                comboTP.map((vcc) => ({
                  value: vcc.ID,
                  label: vcc.TITULO,
                })) as any
              }
              placeholder="Seleccione"
              value={refComboTP || ""}
              isClearable={true}
              onChange={async (e: any) => {
                setValComboTP(e);
                setValComboPS(null);
                setValComboPR(null);
                setComboPR([]);
                let paramsActive = {
                  ...cParamsActiveOrderTitle,
                  TIPO_PROCESO: e.label,
                };
                const comboPS = (await getAPI(`${URL_SUPPORT}${API_ADMIN_PRODUCTO}/getall`, { Authorization: `Bearer ${token}` }, paramsActive))
                  .result.data;

                setComboPS(comboPS);
              }}
            />
          </div>
          <div className="col-sm-12 col-md-6 col-lg-4 pt-0"></div>
          <div className="col-sm-12 col-md-6 col-lg-4 pt-0">
            <label>Producto o servicio</label>
          </div>
          <div className="col-sm-12 col-md-6 col-lg-4 pt-0">
            <Select
              options={
                comboPS.map((vcc) => ({
                  value: vcc.ID,
                  label: vcc.TITULO,
                })) as any
              }
              placeholder="Seleccione"
              value={refComboPS || ""}
              isClearable={true}
              onChange={async (e: any) => {
                setValComboPS(e);
                setValComboPR(null);
                let paramsActive = {
                  ...cParamsActiveOrderTitle,
                  PRODUCTO: e.label,
                };
                const comboPR = (await getAPI(`${URL_SUPPORT}${API_ADMIN_PROVEEDOR}/getall`, { Authorization: `Bearer ${token}` }, paramsActive))
                  .result.data;

                setComboPR(comboPR);
              }}
            />
          </div>
          <div className="col-sm-12 col-md-6 col-lg-4 pt-0"></div>
          <div className="col-sm-12 col-md-6 col-lg-4 pt-0">
            <label>Proveedor</label>
          </div>
          <div className="col-sm-12 col-md-6 col-lg-4 pt-0">
            <Select
              options={
                comboPR.map((vcc) => ({
                  value: vcc.ID,
                  label: vcc.TITULO,
                })) as any
              }
              placeholder="Seleccione"
              value={refComboPR || ""}
              isClearable={true}
              onChange={async (e: any) => {
                setValComboPR(e);
              }}
            />
          </div>
          <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
            <button
              type="button"
              className="btn btn-sm btn-primary me-2"
              onClick={() => {
                filter(filtersState);
              }}>
              {" "}
              <i className="bi bi-search me-2"></i> Buscar
            </button>
            <button
              hidden={!crearPrograma || isHistorico}
              type="button"
              className="btn btn-sm btn-primary me-2"
              onClick={() => {
                window.location.href = "/agregarprograma";
              }}>
              {" "}
              <i className="bi bi-plus-circle me-2"></i>Crear programa
            </button>
            <button
              type="button"
              className="btn btn-sm btn-primary me-2"
              onClick={() => {
                exportar({}, false, 1);
              }}>
              {" "}
              <i className="bi bi-file-earmark-excel"></i>Exporta Excel
            </button>
            <button
              type="button"
              hidden={!isValidate}
              className="btn btn-sm btn-primary me-2"
              onClick={() => {
                validar();
              }}>
              {" "}
              <i className="bi bi-pencil me-2"></i>Validación
            </button>
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={() => {
                limpiar();
              }}>
              {" "}
              <i className="bi bi-trash me-2"></i>Limpiar
            </button>
          </div>
        </div>
      </div>
      <div className="" id="collapseGeneradas">
        {!isHistorico ? (
          <AdminListaPaginationTab
            titleS="Tipo de proceso"
            subtitle="Estudio de ajustes y protecciones"
            defaultSortBy="ID"
            sortDirection="DESC"
            totalPages={totalPageList}
            resultPerPage={ROW_COUNT}
            callback={(pagination: any) => {
              reload(pagination);
            }}
            data={listPlanificaciones || []}
            reload={() => {
              limpiar();
            }}
            columnsDef={columnsDef}
            hideAdd={true}
            hideExport={true}
            exportar={() => {
              exportar({}, false, 1);
            }}
            title="TP"
          />
        ) : (
          <AdminLista
            hideAdd={true}
            hideExport={true}
            data={listPlanificaciones || []}
            callback={() => {}}
            reload={filter}
            filter={filter}
            pagination={{
              pages: pages,
              page: page,
              paging: paging,
            }}
            tipo="Programaciones"
            columnsDef={columnsDefProveedores}
            isLoading={isLoading}
            callbackUpdatePageSize={(pageSize: number, filters: Object) => {
              setPageSize(pageSize);
              filter(filters, false, pageSize);
            }}
          />
        )}
      </div>
    </div>
  );
}
